export const USER_STATUS_NEW = "new";
export const USER_STATUS_PENDING = "pending";
export const USER_STATUS_ACTIVE = "active";
export const USER_STATUS_BANNED = "banned";
export const USER_STATUS_INVITED = "invited";
export const USER_STATUS_REJECTED = "rejected";

export const LINKED_IN_USER_URL = "linkedin.com/in/";
export const FACEBOOK_USER_URL = "facebook.com/";
export const INSTAGRAM_USER_URL = "instagram.com/";
export const TIKTOK_USER_URL = "tiktok.com/@";

export const USER_LANGUAGE_EN = "en";
export const USER_LANGUAGE_NL = "nl";
export const USER_LANGUAGE_FR = "fr";
export const USER_LANGUAGE_DE = "de";

export const USER_LANGUAGES = [
  { value: USER_LANGUAGE_EN, label: "English" },
  { value: USER_LANGUAGE_NL, label: "Dutch" },
  { value: USER_LANGUAGE_FR, label: "French" },
  { value: USER_LANGUAGE_DE, label: "German" },
];
